const isCurrent = (entry, now) => {
  if (entry?.status !== "active") return false;
  if (entry.active === false) return false;
  if (entry.valid_until) {
    const expiry = Date.parse(entry.valid_until);
    if (!Number.isFinite(expiry) || expiry <= now) return false;
  }
  return true;
};

// Halo ownership proof: the website `halo-supervpn` entitlement or the
// consumer-platform `halo` entitlement id (catalog entitlement_code "halo").
export const HALO_ENTITLEMENT_IDS = Object.freeze(["halo-supervpn", "halo"]);

/**
 * Account display only. The server must still issue and verify each edition's
 * entitlement before the app can activate it or offer a download.
 */
export function fortressOwnership({
  customerId,
  websiteEntitlements,
  consumerAccount,
  consumerEntitlement,
  consumerHaloEntitlement,
  consumerReady,
  consumerAccountError,
  consumerEntitlementError,
  now = Date.now(),
}) {
  const websiteHalo = Array.isArray(websiteEntitlements)
    && websiteEntitlements.some((entry) => HALO_ENTITLEMENT_IDS.includes(entry?.product) && isCurrent(entry, now));
  const sameAccount = Boolean(customerId)
    && String(consumerAccount?.customer_id || "") === String(customerId);
  const consumerAvailable = Boolean(consumerReady)
    && sameAccount
    && !consumerAccountError
    && !consumerEntitlementError;
  const proCheckAvailable = consumerAvailable && consumerEntitlement != null;
  const secureMacPro = proCheckAvailable
    && consumerEntitlement.product === "securemac-pro"
    && consumerEntitlement.active === true
    && isCurrent(consumerEntitlement, now);
  const consumerHalo = consumerAvailable
    && consumerHaloEntitlement != null
    && consumerHaloEntitlement.product === "halo"
    && consumerHaloEntitlement.active === true
    && isCurrent(consumerHaloEntitlement, now);
  const halo = Boolean(websiteHalo || consumerHalo);

  return {
    halo,
    // Website Halo ownership is visible here, but the consumer checkout can
    // apply the bundle price only after its own Halo authority is current.
    haloPriceLinkPending: Boolean(websiteHalo && !consumerHalo),
    secureMacPro: Boolean(secureMacPro),
    baseQualified: halo,
    proQualified: Boolean(halo && secureMacPro),
    // Fortress Pro add-on (US$11.99 once) applies to an active Halo customer
    // who does not already own SecureShield Pro.
    proAddonEligible: Boolean(halo && proCheckAvailable && !secureMacPro),
    proCheckAvailable,
  };
}
